import { X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import type { FamilyDto } from '../add-item/types'

interface FamilyEditorSidebarHeaderProps {
  family: FamilyDto
  mode: 'create' | 'update'
  onClose: () => void
}

export function FamilyEditorSidebarHeader({ family, mode, onClose }: FamilyEditorSidebarHeaderProps) {
  return (
    <div className="sticky top-0 z-10 bg-background border-b px-6 py-4">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="flex items-center gap-3">
            <div className="text-2xl leading-none">{family.icon}</div>
            <div className="min-w-0">
              <h2 className="text-base font-semibold truncate">
                {mode === 'update' ? 'Modifier la ligne' : 'Ajouter une ligne'}
              </h2>
              <div className="text-xs text-muted-foreground truncate">{family.familyLabel}</div>
            </div>
          </div>
        </div>

        <Button variant="ghost" size="icon" onClick={onClose} className="flex-shrink-0">
          <X className="h-5 w-5" />
        </Button>
      </div>
    </div>
  )
}
